package com.anjuros.website.redesign.sections.trades

import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

/**
 * One trade in the directory. Trades with their own page link to it ([pageLink] set);
 * the rest suggest the design that suits them best.
 */
class TradeRow(
    val title: RdText,
    val text: RdText,
    val keywords: RdText,
    val path: String,
    val pageLink: RdText? = null,
    val suggestedDesign: RdText? = null,
)

class TradeGroup(
    val id: String,
    val sector: RdText,
    val title: RdText,
    val text: RdText,
    val rows: List<TradeRow>,
)

val TradeGroups = listOf(
    TradeGroup(
        "building", RdText.SECTOR_BUILDING, RdText.GROUP_BUILDING, RdText.GROUP_BUILDING_TEXT, listOf(
            TradeRow(RdText.ROW_ELECTRICIANS, RdText.ROW_ELECTRICIANS_TEXT, RdText.ROW_ELECTRICIANS_KEYWORDS, RdRoute.ELECTRICIAN, pageLink = RdText.ROW_ELECTRICIANS_LINK),
            TradeRow(RdText.ROW_PLUMBERS, RdText.ROW_PLUMBERS_TEXT, RdText.ROW_PLUMBERS_KEYWORDS, RdRoute.ELECTRICIAN, suggestedDesign = RdText.DESIGN_NAME_ELECTRICIAN),
            TradeRow(RdText.ROW_HANDYMEN, RdText.ROW_HANDYMEN_TEXT, RdText.ROW_HANDYMEN_KEYWORDS, RdRoute.HANDYMAN, pageLink = RdText.ROW_HANDYMEN_LINK),
            TradeRow(RdText.ROW_DECORATORS, RdText.ROW_DECORATORS_TEXT, RdText.ROW_DECORATORS_KEYWORDS, RdRoute.DECORATOR, pageLink = RdText.ROW_DECORATORS_LINK),
            TradeRow(RdText.ROW_CARPENTERS, RdText.ROW_CARPENTERS_TEXT, RdText.ROW_CARPENTERS_KEYWORDS, RdRoute.DECORATOR, suggestedDesign = RdText.DESIGN_NAME_DECORATOR),
        )
    ),
    TradeGroup(
        "outdoor", RdText.SECTOR_OUTDOOR, RdText.GROUP_OUTDOOR, RdText.GROUP_OUTDOOR_TEXT, listOf(
            TradeRow(RdText.ROW_GARDENERS, RdText.ROW_GARDENERS_TEXT, RdText.ROW_GARDENERS_KEYWORDS, RdRoute.DECORATOR, suggestedDesign = RdText.DESIGN_NAME_DECORATOR),
            TradeRow(RdText.ROW_CLEANERS, RdText.ROW_CLEANERS_TEXT, RdText.ROW_CLEANERS_KEYWORDS, RdRoute.HANDYMAN, suggestedDesign = RdText.DESIGN_NAME_HANDYMAN),
        )
    ),
    TradeGroup(
        "beauty", RdText.SECTOR_BEAUTY, RdText.GROUP_BEAUTY, RdText.GROUP_BEAUTY_TEXT, listOf(
            TradeRow(RdText.ROW_HAIRDRESSERS, RdText.ROW_HAIRDRESSERS_TEXT, RdText.ROW_HAIRDRESSERS_KEYWORDS, RdRoute.HAIRDRESSER, pageLink = RdText.ROW_HAIRDRESSERS_LINK),
            TradeRow(RdText.ROW_INSTRUCTORS, RdText.ROW_INSTRUCTORS_TEXT, RdText.ROW_INSTRUCTORS_KEYWORDS, RdRoute.INSTRUCTOR, pageLink = RdText.ROW_INSTRUCTORS_LINK),
        )
    ),
    TradeGroup(
        "food", RdText.SECTOR_FOOD, RdText.GROUP_FOOD, RdText.GROUP_FOOD_TEXT, listOf(
            TradeRow(RdText.ROW_BAKERS, RdText.ROW_BAKERS_TEXT, RdText.ROW_BAKERS_KEYWORDS, RdRoute.BAKER, pageLink = RdText.ROW_BAKERS_LINK),
            TradeRow(RdText.ROW_PUBS, RdText.ROW_PUBS_TEXT, RdText.ROW_PUBS_KEYWORDS, RdRoute.PUB, pageLink = RdText.ROW_PUBS_LINK),
        )
    ),
    TradeGroup(
        "local", RdText.SECTOR_LOCAL, RdText.GROUP_LOCAL, RdText.GROUP_LOCAL_TEXT, listOf(
            TradeRow(RdText.ROW_DOG_WALKERS, RdText.ROW_DOG_WALKERS_TEXT, RdText.ROW_DOG_WALKERS_KEYWORDS, RdRoute.DOG_WALKER, pageLink = RdText.ROW_DOG_WALKERS_LINK),
            TradeRow(RdText.ROW_OTHER, RdText.ROW_OTHER_TEXT, RdText.ROW_OTHER_KEYWORDS, RdRoute.DESIGNS, suggestedDesign = RdText.DESIGN_NAME_ANY),
        )
    ),
)
